<!--后台管理——统计分析页面-->
<template>
  <div class="app-container">
    <div class="table_line">
      <div class="inner_left">
        <div class="inner_title">人房地分析</div>
        <div class="inner_line">
          <div class="table_item">
            <div class="item_content">
              <img src="../../assets/icon-table1.png" alt="" class="item_icon">
              <div class="item_text">
                <div class="item_num">{{peopleData.count}}</div>
                <div class="item_name">常住人口（人）</div>
              </div>
            </div>
<!--            <div class="item_hint"><span>占总人口：</span><span class="hint_num">{{peopleData.rate}}</span></div>-->
          </div>
          <div class="table_item">
            <div class="item_content">
              <img src="../../assets/icon-table2.png" alt="" class="item_icon">
              <div class="item_text">
                <div class="item_num">{{residenceData.count}}</div>
                <div class="item_name">住房数量（人）</div>
              </div>
            </div>
            <!-- <div class="item_hint"><span>占总人口：</span><span class="hint_num">{{residenceData.rate}}</span></div> -->
          </div>
          <div class="table_item">
            <div class="item_content">
              <img src="../../assets/icon-table3.png" alt="" class="item_icon">
              <div class="item_text">
                <div class="item_num">{{companyData.count}}</div>
                <div class="item_name">企业数量（个）</div>
              </div>
            </div>
            <!-- <div class="item_hint"><span>占总人口：</span><span class="hint_num">{{companyData.rate}}</span></div> -->
          </div>
          <div class="table_item">
            <div class="item_content">
              <img src="../../assets/icon-table4.png" alt="" class="item_icon">
              <div class="item_text">
                <div class="item_num">{{nineOneData.count}}</div>
                <div class="item_name">9+1场所（个）</div>
              </div>
            </div>
            <!-- <div class="item_hint"><span>占总人口：</span><span class="hint_num">{{nineOneData.count}}</span></div> -->
          </div>
          <div class="table_item">
            <div class="item_content">
              <img src="../../assets/icon-table5.png" alt="" class="item_icon">
              <div class="item_text">
                <div class="item_num">{{templeBeliefData.count}}</div>
                <div class="item_name">宗教场所及民间信仰点数量（个）</div>
              </div>
            </div>
            <!-- <div class="item_hint"><span>占总人口：</span><span class="hint_num">{{templeBeliefData.rate}}</span></div> -->
          </div>
          <div class="table_item">
            <div class="item_content">
              <img src="../../assets/icon-table6.png" alt="" class="item_icon">
              <div class="item_text">
                <div class="item_num">{{householdData.count}}</div>
                <div class="item_name">出租户数量（个）</div>
              </div>
            </div>
            <!-- <div class="item_hint"><span>占总人口：</span><span class="hint_num">{{householdData.rate}}</span></div> -->
          </div>
          <div class="table_item">
            <div class="item_content">
              <img src="../../assets/icon-table7.png" alt="" class="item_icon">
              <div class="item_text">
                <div class="item_num">{{careChildData.count}}</div>
                <div class="item_name">关怀人群数量（人）</div>
              </div>
            </div>
            <!-- <div class="item_hint"><span>占总人口：</span><span class="hint_num">{{careChildData.rate}}</span></div> -->
          </div>
          <div class="table_item">
            <div class="item_content">
              <img src="../../assets/icon-table8.png" alt="" class="item_icon">
              <div class="item_text">
                <div class="item_num">{{partyMemberData.count-1}}</div>
                <div class="item_name">党员数量（人）</div>
              </div>
            </div>
            <!-- <div class="item_hint"><span>占总人口：</span><span class="hint_num">{{partyMemberData.rate}}</span></div> -->
          </div>
        </div>
      </div>
      <div class="inner_right">
        <div class="inner_title"><span>积分排名</span><span class="more_button">更多</span></div>
        <div class="rank_list">
          <div class="rank_item" v-if="rankList.length>0">
            <div class="rank_num">
              <img src="../../assets/icon-rank1.png" alt="" class="rank_icon">
              <div class="rank_text" style="color: white;font-size: 14px;top: 55%;font-weight: 500">01</div>
            </div>
            <div class="rank_name">{{rankList[0].name}}</div>
            <div class="rank_value">{{rankList[0].branch}}</div>
          </div>
          <div class="rank_item" v-if="rankList.length>1">
            <div class="rank_num">
              <img src="../../assets/icon-rank2.png" alt="" class="rank_icon">
              <div class="rank_text" style="color: white;font-size: 14px;top: 55%;font-weight: 500">02</div>
            </div>
            <div class="rank_name">{{rankList[1].name}}</div>
            <div class="rank_value">{{rankList[1].branch}}</div>
          </div>
          <div class="rank_item" v-if="rankList.length>2">
            <div class="rank_num">
              <img src="../../assets/icon-rank3.png" alt="" class="rank_icon">
              <div class="rank_text" style="color: white;font-size: 14px;top: 55%;font-weight: 500">03</div>
            </div>
            <div class="rank_name">{{rankList[2].name}}</div>
            <div class="rank_value">{{rankList[2].branch}}</div>
          </div>
          <div class="rank_item" v-if="rankList.length>3">
            <div class="rank_num">
              <img src="../../assets/icon-rank1.png" alt="" style="opacity: 0;" class="rank_icon">
              <div class="rank_text">04</div>
            </div>
            <div class="rank_name">{{rankList[3].name}}</div>
            <div class="rank_value">{{rankList[3].branch}}</div>
          </div>
          <div class="rank_item" v-if="rankList.length>4">
            <div class="rank_num">
              <img src="../../assets/icon-rank1.png" alt="" style="opacity: 0;" class="rank_icon">
              <div class="rank_text">05</div>
            </div>
            <div class="rank_name">{{rankList[4].name}}</div>
            <div class="rank_value">{{rankList[4].branch}}</div>
          </div>
          <div class="rank_item" v-if="rankList.length>5">
            <div class="rank_num">
              <img src="../../assets/icon-rank1.png" alt="" style="opacity: 0;" class="rank_icon">
              <div class="rank_text">06</div>
            </div>
            <div class="rank_name">{{rankList[5].name}}</div>
            <div class="rank_value">{{rankList[5].branch}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="second_line">
      <div class="inner_left">
        <div class="inner_title">党建分析</div>
        <div class="inner_line">
          <div class="inner_item">
            <ec-pie type="标准环" class="nomal_pie" :data="pieData1" title="党支部分析"
                    style="width: 100%;height: 100%"></ec-pie>
            <ec-pie type="简略环" class="brief_pie" :data="pieData1" title="党支部分析"
                    style="width: 100%;height: 100%"></ec-pie>
          </div>
          <div class="inner_item">
            <ec-pie type="标准环" class="nomal_pie" title="学历分析" style="width: 100%;height: 100%"
                    :data="pieData2"></ec-pie>
            <ec-pie type="简略环" class="brief_pie" title="学历分析" style="width: 100%;height: 100%"
                    :data="pieData2"></ec-pie>
          </div>
        </div>
      </div>
      <div class="inner_right">
        <div class="inner_title">工单占比</div>
        <div class="inner_content">
          <div class="list_item" v-for="(item,index) in rateList" :key="index">
            <div class="item_info">
              <span class="item_title">{{item.key}}</span>
              <span class="item_rate">{{item.rate}}</span>
            </div>
            <div class="item_process">
              <div class="item_process_front" :style="{width:item.rate,background:colorPad[index]}"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "analysis",
    components: {
      ecPie: () => import('./components/ec-pie')
    },
    created() {
      Promise.all([
        this.getPeopleData(),
        this.getResidenceData(),
        this.getCompanyData(),
        this.getNineOneData(),
        this.getTempleBeliefData(),
        this.getHouseholdData(),
        this.getCareChildData(),
        this.getPartyMemberData(),
        this.getintegralPeopleRank(),
        this.getOrderRate(),
        this.getPartyGroup(),
        this.getPartyEdu(),

      ])
    },
    mounted() {
      window.onresize = this.resizePage()
    },
    data() {
      return {
        colorPad: ['linear-gradient(to right,#FF8C8C,#FF6060)',
          'linear-gradient(to right,#FFB36C,#FFA047)',
          'linear-gradient(to right,#18E1BF,#08DEB2)',
          'linear-gradient(to right,#45ACFE,#2BA1FF)',
          'linear-gradient(to right,#45ACFE,#2BA1FF)'],
        rateList: [{name: 'test1', rate: '59%'}, {name: 'test2', rate: '50%'}, {
          name: 'test3',
          rate: '39%'
        }, {name: 'test4', rate: '25%'}, {name: 'test5', rate: '12%'},],
        pieData1: [{name: 'test1', value: 5}, {name: 'test2', value: 5}, {name: 'test3', value: 5}, {
          name: 'test4',
          value: 5
        }, {name: 'test5', value: 5}],
        pieData2: [{name: 'test1', value: 5}, {name: 'test2', value: 5}, {name: 'test3', value: 5}],
        peopleData: {count: 0, rate: '0%'},
        residenceData: {count: 0, rate: '0%'},
        companyData: {count: 0, rate: '0%'},
        nineOneData: {count: 0, rate: '0%'},
        templeBeliefData: {count: 0, rate: '0%'},
        householdData: {count: 0, rate: '0%'},
        careChildData: {count: 0, rate: '0%'},
        partyMemberData: {count: 0, rate: '0%'},
        rankList: [{name: 'test1', branch: '0'}, {name: 'test1', branch: '0'}, {
          name: 'test1',
          branch: '0'
        }, {name: 'test1', branch: '0'}, {name: 'test1', branch: '0'}, {name: 'test1', branch: '0'},],
      }
    },
    methods: {
      getPeopleData() {
        this.$http.get('api/threeScreen/statistics/people').then(res => {
          if (res.data.code == 200) {
            this.peopleData = res.data.data
          }
        })
      },
      getResidenceData() {
        this.$http.get('api/threeScreen/statistics/residence').then(res => {
          if (res.data.code == 200) {
            this.residenceData = res.data.data
          }
        })
      },
      getCompanyData() {
        this.$http.get('api/threeScreen/statistics/company').then(res => {
          if (res.data.code == 200) {
            this.companyData = res.data.data
          }
        })
      },
      getNineOneData() {
        this.$http.get('api/threeScreen/statistics/nineOne').then(res => {
          if (res.data.code == 200) {
            this.nineOneData = res.data.data
          }
        })
      },
      getTempleBeliefData() {
        this.$http.get('api/threeScreen/statistics/templeBelief').then(res => {
          if (res.data.code == 200) {
            this.templeBeliefData = res.data.data
          }
        })
      },
      getHouseholdData() {
        this.$http.get('api/threeScreen/statistics/household').then(res => {
          if (res.data.code == 200) {
            this.householdData = res.data.data
          }
        })
      },
      getCareChildData() {
        this.$http.get('api/threeScreen/statistics/careChild').then(res => {
          if (res.data.code == 200) {
            this.careChildData = res.data.data
          }
        })
      },
      getPartyMemberData() {
        this.$http.get('api/threeScreen/statistics/partyMember').then(res => {
          if (res.data.code == 200) {
            this.partyMemberData = res.data.data
          }
        })
      },
      getintegralPeopleRank() {
        this.$http.get('api/threeScreen/statistics/integralPeople').then(res => {
          if (res.data.code == 200) {
            this.rankList = res.data.data.list
          }
        })
      },
      getOrderRate() {
        this.$http.get('api/threeScreen/statistics/workOrderRate').then(res => {
          if (res.data.code == 200) {
            this.rateList = res.data.data
          }
        })
      },
      getPartyGroup() {
        this.$http.get('api/threeScreen/statistics/partyMemberGroup').then(res => {
          if (res.data.code == 200) {
            let data = res.data.data
            data.forEach(item => {
              item.name = item.key
            })
            this.pieData1 = JSON.parse(JSON.stringify(data))
          }
        })
      },
      getPartyEdu() {
        this.$http.get('api/threeScreen/statistics/partyMemberEdu').then(res => {
          if (res.data.code == 200) {
            let data = res.data.data
            data.forEach(item => {
              item.name = item.key
            })
            this.pieData2 = JSON.parse(JSON.stringify(data))
          }
        })
      },
    }
  }
</script>

<style scoped lang="less">
  .app-container {
    width: 100%;
    min-height: 100%;
    background: rgba(247, 248, 250, 1);

    .table_line {
      padding: 8px 0;
      display: flex;
      justify-content: space-between;

      .inner_left {
        width: 75%;
        background: white;
        box-shadow: 0px 2px 4px 0px rgba(38, 45, 59, 0.03);
        padding: 24px 20px;

        .inner_title {
          font-size: 22px;
          font-weight: bold;
          color: #222222;
          line-height: 30px;
          margin-bottom: 20px;
        }

        @media screen and (min-width: 1631px) {

          .inner_line {
            width: 100%;
            display: grid;
            grid-column-gap: 1%;
            grid-row-gap: 10px;
            grid-template-columns: 24% 24% 24% 24%;
            /*justify-content: space-between;*/
            /*align-items: center;*/

            .table_item {
              width: 100%;
              background: linear-gradient(to bottom, #FAFCFF 0%, #FFFFFF 100%);

              .item_content {
                padding: 12px 18px;
                display: flex;
                align-items: center;
                border-bottom: 1px dashed #EEEFF0;


                .item_icon {
                  width: 54px;
                }

                .item_text {
                  margin-left: 16px;

                  .item_num {
                    font-size: 38px;
                    font-weight: bold;
                    color: #222222;
                    line-height: 57px;
                  }

                  .item_name {
                    font-size: 18px;
                    font-weight: 400;
                    color: #555555;
                    line-height: 25px;
                  }
                }
              }

              .item_hint {
                display: flex;
                align-items: center;
                padding: 12px 18px;
                font-size: 18px;
                font-weight: 400;
                color: #555555;
                line-height: 25px;

                .hint_num {
                  font-size: 24px;
                  font-family: DINAlternate-Bold, DINAlternate;
                  font-weight: bold;
                  color: #2977FF;
                  line-height: 28px;
                }
              }
            }
          }
        }

        @media screen and (min-width: 900px ) and (max-width: 1630px) {
          .inner_line {
            width: 100%;
            display: grid;
            grid-column-gap: 0.8%;
            grid-template-columns: 32.5% 32.5% 32.5%;
            /*justify-content: space-between;*/
            /*align-items: center;*/

            .table_item {
              width: 100%;
              background: linear-gradient(to bottom, #FAFCFF 0%, #FFFFFF 100%);

              .item_content {
                padding: 16px 20px;
                display: flex;
                align-items: center;
                border-bottom: 1px dashed #EEEFF0;


                .item_icon {
                  width: 54px;
                }

                .item_text {
                  margin-left: 16px;

                  .item_num {
                    font-size: 38px;
                    font-weight: bold;
                    color: #222222;
                    line-height: 57px;
                  }

                  .item_name {
                    font-size: 18px;
                    font-weight: 400;
                    color: #555555;
                    line-height: 25px;
                  }
                }
              }

              .item_hint {
                display: flex;
                align-items: center;
                padding: 16px 20px;
                font-size: 18px;
                font-weight: 400;
                color: #555555;
                line-height: 25px;

                .hint_num {
                  font-size: 24px;
                  font-family: DINAlternate-Bold, DINAlternate;
                  font-weight: bold;
                  color: #2977FF;
                  line-height: 28px;
                }
              }
            }
          }

        }

      }

      .inner_right {
        width: 24%;
        background: white;
        box-shadow: 0px 2px 4px 0px rgba(38, 45, 59, 0.03);
        padding: 24px 20px;

        .inner_title {
          font-size: 22px;
          font-weight: 500;
          color: #222222;
          line-height: 30px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .more_button {
            font-size: 18px;
            font-weight: 400;
            color: #888888;
            line-height: 25px;
          }
        }

        .rank_list {
          height: 85%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .rank_item:nth-child(1) {
            background: linear-gradient(180deg, #FFFCFA 0%, #FEF8F3 100%);
          }

          .rank_item:nth-child(2) {
            background: linear-gradient(180deg, #FAFCFF 0%, #F4F8FF 100%);
          }

          .rank_item:nth-child(3) {
            background: linear-gradient(180deg, #FFFCFC 0%, #FFF7F7 100%);
          }

          .rank_item {
            height: 42px;
            margin: 7px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #FCFCFC;
            padding: 0 8px;

            .rank_num {
              position: relative;
              width: 10%;

              .rank_icon {
                width: 100%;
              }

              .rank_text {
                width: 36px;
                text-align: center;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                font-size: 18px;
                font-weight: 400;
                color: #222222;
                line-height: 25px;
              }
            }

            .rank_name {
              font-size: 18px;
              font-weight: 400;
              color: #222222;
              line-height: 25px;
            }

            .rank_value {
              font-size: 18px;
              font-weight: 400;
              color: #222222;
              line-height: 25px;
            }
          }
        }
      }
    }

    .second_line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 420px;
      padding: 8px 0;

      .inner_left {
        width: 75%;
        height: 100%;
        background: white;
        box-shadow: 0px 2px 4px 0px rgba(38, 45, 59, 0.03);
        padding: 24px 20px;

        .inner_title {
          font-size: 22px;
          font-weight: bold;
          color: #222222;
          line-height: 30px;
          margin-bottom: 20px;
        }

        .inner_line {
          width: 100%;
          height: 88%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .inner_item {
            width: 49%;
            flex-shrink: 1;
            height: 100%;
            background: linear-gradient(to bottom, #FAFCFF 0%, #FAFCFF 90%, #FFFFFF 100%);

            @media screen and(max-width: 1630px) {
              .nomal_pie {
                display: none;
              }

              .brief_pie {
                display: block;
              }
            }

            @media screen and (min-width: 1630px) {
              .nomal_pie {
                display: block;
              }

              .brief_pie {
                display: none;
              }
            }
          }
        }
      }

      .inner_right {
        width: 24%;
        height: 100%;
        background: white;
        box-shadow: 0px 2px 4px 0px rgba(38, 45, 59, 0.03);
        padding: 24px 20px;

        .inner_title {
          font-size: 22px;
          font-weight: 500;
          color: #222222;
          line-height: 30px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .inner_content {
          width: 100%;
          height: 88%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .list_item {
            width: 100%;
            height: 20%;

            .item_info {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .item_title {
                font-size: 16px;
                font-weight: 400;
                color: #555555;
                line-height: 22px;
              }

              .item_rate {
                font-size: 24px;
                font-weight: bold;
                color: #222222;
                line-height: 28px;
              }
            }

            .item_process {
              position: relative;
              margin-top: 8px;
              width: 100%;
              height: 10px;
              background: #EAEDF3;
              border-radius: 2px;
              overflow: hidden;

              .item_process_front {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
</style>
